import React from "react";
import { Row, Col } from "react-bootstrap";

import Input from "../../Input";
import Img from "../../Img";
import Fieldset from "../../Fieldset";

import { Container, GridCDOC, CDOC, Videos } from "./styles";

import useProduct from "./useProduct";

const Product = ({ id, client }) => {
    const { data, productInfos, videos, handleSelectDocument, createLogCDOC } =
        useProduct({
            id,
            client,
        });

    const cdocItems = [
        {
            key: "CDOC1",
            label: "Literatura",
            onClick: () => handleSelectDocument("CDOC1"),
            isAvailable: !!data.CDOC1,
            unavailableMsg: (
                <p>
                    Não disponível.
                    <br /> Solicitar a Empresa
                </p>
            ),
        },
        {
            key: "CDOC2",
            label: "FDS",
            onClick: () => handleSelectDocument("CDOC2"),
            isAvailable: !!data.CDOC2,
            unavailableMsg: (
                <p>
                    Não disponível.
                    <br /> Solicitar a Empresa
                </p>
            ),
        },
        {
            key: "CDOC3",
            label: "LAUDOS",
            onClick: () => handleSelectDocument("CDOC3"),
            isAvailable: !!data.CDOC3,
            unavailableMsg: (
                <p>
                    Esse produto não pussui laudos obrigatórios de acordo com a
                    legislação vigente
                </p>
            ),
        },
        {
            key: "CDOC4",
            label: "Conheça melhor o produto para vender",
            onClick: () => handleSelectDocument("CDOC4"),
            isAvailable: !!data.CDOC4,
            unavailableMsg: <p>Não disponível</p>,
        },
        {
            key: "CDOC5",
            label: "Material publicitário de apoio",
            onClick: () => {
                productInfos.forEach((item) => window.open(item, "_blank"));
                createLogCDOC(client, 5);
            },
            isAvailable: productInfos.length > 0,
            unavailableMsg: <p>Não disponível</p>,
        },
    ];

    return (
        <Container>
            <Row>
                <Col className="d-flex justify-center">
                    <Img
                        src={data.image}
                        alt="CDOCs Produto Noorhen"
                        max-width="200px"
                        max-height="200px"
                        min-width="200px"
                    />
                </Col>
                <Col>
                    <Input
                        type="text"
                        id="Titulo"
                        label="Título:"
                        value={data.Titulo}
                        readOnly
                    />
                </Col>
            </Row>
            <Fieldset className="form__checkbox-products--border">
                <h3>CDOCS</h3>
                <Row className="justify-center">
                    {cdocItems.map((cdoc) => (
                        <GridCDOC key={cdoc.key}>
                            {cdoc.isAvailable ? (
                                <CDOC
                                    onClick={(e) => {
                                        e.preventDefault();
                                        cdoc.onClick();
                                    }}
                                >
                                    <span>{cdoc.label}</span>
                                </CDOC>
                            ) : null}
                        </GridCDOC>
                    ))}
                </Row>
            </Fieldset>
            <Videos>
                <h3>Vídeos</h3>
                {videos.map((video) => (
                    <li key={Math.random()} className="video-item">
                        <a
                            href={video.link}
                            rel="noopener noreferrer"
                            target="_blank"
                        >
                            {video.link}
                        </a>
                    </li>
                ))}
            </Videos>
        </Container>
    );
};

export default Product;
